import {useState, useEffect} from 'react';

export default function DeleteorderActionImpl(){

    return (
        <>
        <div>DeleteorderActionImpl</div>
        </>
    )
}